/* -------------------------------------------------------------------------------- *\
|                               getversion
\* -------------------------------------------------------------------------------- */
export const getversion = (): string =>
{
    return "bdd-python race tools @mclloyd 2026 - version 1.0.7";
}
